import React from 'react';
import { StoreOpeningHoursSpotModule } from '~/lib/data-contract';

import { useTranslation } from '~/shared/utils/translation';
import { StoreTime, StyledDd, StyledInfo } from '../CardStore';
import { StyledStoreOpeningHoursContainer, StyledStoreWrapper } from '../styled';

type StoreOpeningHoursProps = StoreOpeningHoursSpotModule;

export const StoreOpeningHoursSpot = ({
    storeList,
    spacingBottom,
    spacingTop,
    border,
}: StoreOpeningHoursProps) => {
    const { translate } = useTranslation();

    return (
        <StyledStoreWrapper
            aria-label={`Overblik over åbningstider for ` + storeList?.name}
            spacingBottom={spacingBottom}
            spacingTop={spacingTop}
            border={border}
        >
            <StyledStoreOpeningHoursContainer>
                <StyledInfo>
                    {Array.isArray(storeList?.c_openingHours) &&
                        storeList?.c_openingHours.map(
                            (storeOption: StoreTime | undefined | null) => {
                                return (
                                    <StyledDd
                                        aria-label={
                                            storeOption?.opens
                                                ? 'Åbent fra ' +
                                                  `${storeOption?.opens} ` +
                                                  'ti ' +
                                                  `${storeOption?.closes}`
                                                : 'Lukket'
                                        }
                                    >
                                        <dl>{storeOption?.day}</dl>
                                        <dl>
                                            {storeOption?.opens ? (
                                                <>
                                                    {storeOption?.opens} - {storeOption?.closes}
                                                </>
                                            ) : (
                                                <>{translate('pdp.closedStore')}</>
                                            )}
                                        </dl>
                                    </StyledDd>
                                );
                            },
                        )}
                </StyledInfo>
            </StyledStoreOpeningHoursContainer>
        </StyledStoreWrapper>
    );
};
